/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import config from '../../../../config';
import moduleServices from '../../../../redux/services/moduleServices';

const useStyles = makeStyles(() => ({
  iframe: {
    border: '0',
    width: '100%',
    boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.05) !important',
    backgroundColor: '#fff',
  },
  rise: {
    height: '100rem',
  },
  storyline: {
    height: '96%',
  },
}));

const StorylineContent = ({
  filename, launchPoint, unitId, userName, email, activityId, rise, userData, group, currentGroup,
}) => {
  const classes = useStyles();
  const [inProgress, setInProgress] = useState(0);
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const [open, setOpen] = useState(false);
  const [openPresenting, setOpenPresenting] = useState(false);

  useEffect(() => {
    setInProgress(0);
    if (userData !== undefined && group.data[currentGroup]._id.length > 0) {
      moduleServices.globalResultsTest(userData._id, userData.email, group.data[currentGroup]._id)
        .then((results) => {
          if (results && results.length > 0) {
            results[0].forEach((module) => {
              module.units.forEach((unit) => {
                if (unit.unit.activityId.toString() === activityId && unit.unit.time && inProgress >= 0) {
                  if (!unit.unit.activityId.includes('rise')) {
                    setInProgress(unit.unit.time);
                  }
                }
              });
            });
          }
        })
        .catch(() => {
          setErrorSnackBar({ code: 2301, message: 'Missing global results.', severity: 'warning' });
        });
    }
  }, [userData, group.data[currentGroup]._id, activityId]);

  useEffect(() => {
    if (inProgress > 0 && unitId !== '60228d8d28b16a0179735de7') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [inProgress, activityId]);

  useEffect(() => {
    if (unitId === '60228d8d28b16a0179735de7') {
      setOpenPresenting(true);
    } else {
      setOpenPresenting(false);
    }
  }, [unitId]);

  return (
    <>
      <Snackbar open={open} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} aria-live="polite" aria-atomic="true">
        <Alert severity="info" variant="filled" onClose={() => { setOpen(false); }} aria-live="assertive" aria-atomic="true">
          Pour recommencer/réinitialiser une unité, cliquez sur `Restart` au lieu de `Continue`
        </Alert>
      </Snackbar>
      <Snackbar open={openPresenting} onClose={() => { setOpenPresenting(false); }} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} aria-live="polite" aria-atomic="true">
        <Alert severity="info" variant="filled" onClose={() => { setOpen(false); }} aria-live="assertive" aria-atomic="true">
          {'Vous n\'êtes pas dans l\'obligation de compléter tous les éléments du module "Presentation Builder"'}
        </Alert>
      </Snackbar>
      <Snackbar open={errorSnackBar !== null} onClose={() => { setErrorSnackBar(null); }} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} aria-live="polite" aria-atomic="true">
        <Alert severity={errorSnackBar !== null ? errorSnackBar.severity : 'info'} variant="filled" onClose={() => { setErrorSnackBar(null); }} aria-live="assertive" aria-atomic="true">
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>
      <Iframe
        loading="Loading..."
        className={`${classes.iframe} ${rise ? classes.rise : classes.storyline}`}
        src={`${config.OBJECT_URL}/content/${filename}/${launchPoint}?endpoint=${config.LRS_ENDPOINT}&actor=%7B%22Name%22%3A%20%5B%22${encodeURI(userName)}%22%5D%2C%20%22mbox%22%3A%20%5B%22mailto%3A${encodeURI(email.trim())}%22%5D%7D&activity_id=http://${activityId}`}
        title="StorylineFrame"
        aria-label={`Storyline module ${filename} launched from ${launchPoint}`}
      />
    </>
  );
};

StorylineContent.propTypes = {
  filename: PropTypes.string.isRequired,
  launchPoint: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  unitId: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  activityId: PropTypes.string.isRequired,
  rise: PropTypes.string.isRequired,
  userData: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  currentGroup: PropTypes.number.isRequired,
};

function mapState(state) {
  const { group } = state;
  const { userData } = state.user;
  const { currentGroup } = state.ui;

  return {
    userData,
    currentGroup,
    group,
  };
}
export default withRouter(connect(mapState, null)(StorylineContent));
